<template>
  <div>
    <section>
      <div class="header">
        <h5>{{newsInfo.ContentTitle}}</h5>
        <div class="clearfix">
          <span class="fl">时间：{{newsInfo.PublishedTime}}</span>
        </div>
      </div>
      <article id="article-content">
        <div v-html="newsInfo.Description"></div>
      </article>
    </section>
    <detail-footer :resource-id="newsData.newsId" :share-data="returnInfo" type="news"/>

    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import share from '@/components/share.vue'
import detailFooter from '@/components/DetailFooter.vue'
export default {
  components: {
    share,
    'footer-logo': footerLogo,
    detailFooter
  },
  data() {
    return {
      shareShow: {
        isShow: false
      },
      isShow: false,
      newsInfo: {},
      newsData: {
        newsId: this.$route.query.id
      },
      returnInfo: {
        title: '',
        desc: '',
        link: location.href,
        image: ''
      }
    }
  },
  created() {
    let newsId = this.$route.params.id
    if (!newsId) newsId = this.$route.query.id
    this.newsData.newsId = newsId

    this.getNewsInfo()
  },
  methods: {
    onShow() {
      this.shareShow.isShow = true
    },
    getNewsInfo() {
      this.$fetch('/api/News/GetNewsDetail', this.newsData).then(result => {
        this.newsInfo = result
        this.returnInfo.title = result.ContentTitle
        this.returnInfo.desc = result.Source
        this.returnInfo.image = result.TitleImagePath

        document.title = result.ContentTitle
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  padding: 30 / @rem-size 24 / @rem-size 20 / @rem-size;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;

  h5 {
    font-size: 32 / @rem-size;
    font-weight: normal;
    color: #333;
    line-height: 48 / @rem-size;
  }

  span {
    color: #999;
    font-size: 28 / @rem-size;
    display: block;
    margin-top: 20 / @rem-size;
  }
}

article {
  background: #fff;
  padding: 24 / @rem-size;
  font-size: 28 / @rem-size;
  line-height: 40 / @rem-size;
}
</style>
